function calcPanels(width) {
  const panels = {
    lg: 0,
    md: 0,
    sm: 0,
    xs: 0,
  };

  panels.lg = Math.floor(width / 2);
  panels.sm = width % 2;

  return panels;
}

function toSplitPanels(panels) {
  if (!panels) return;

  console.log(panels, 'before');

  panels.sm += panels.lg * 2;
  panels.lg = 0;

  panels.sm += panels.md;
  panels.xs += panels.md;
  panels.md = 0;

  console.log(panels, 'after');
}

function getUrl(cart, storeData) {
  const system = storeData.ecommerceSystemName?.toLowerCase();
  if (!system) return;

  if (system === 'shopify') {
    return `${storeData.shopUrl}/cart/${cart
      .map(item => `${item.id}:${item.qty}`)
      .join(',')}`;
  }

  if (system === 'woo') {
    return `${storeData.shopUrl}?items=${cart
      .map(item => item.id)
      .join(',')}&quantities=${cart.map(item => item.qty).join(',')}`;
  }

  if (system === 'magento') {
    return `${storeData.shopUrl}/dpa/add/tocart/sku/${cart
      .map(item => `${item.id}-${item.qty}`)
      .join(',')}`;
  }

  if (system === 'shopware') {
    return `${storeData.shopUrl}/dsvn/quick-cart/add?products=${cart
      .map(item => item.id)
      .join(',')}&quantity=${cart.map(item => item.qty).join(',')}`;
  }
}

export { calcPanels, toSplitPanels, getUrl };
